import React, {FC, useState} from 'react'
import {CardInterface} from '../../../../app/@types'

const CardCollapse: FC<CardInterface> = ({id, title, body, size, toolbar}) => {

  const [toolbarIcon, setToolbarIcon] = useState<boolean>(true)

  const sm = size === "sm"

  return (
    <div className={`card border border-1 mb-5 ${!sm && "mb-xl-10"}`}>
      <div className={`card-header cursor-pointer ${sm && "min-h-50px bg-light-info px-5 px-sm-8 py-3 px-sm-3"}`}
           role="button"
           data-bs-toggle="collapse"
           data-bs-target={`#kt_${id}_card`}
           aria-expanded="true"
           aria-controls={`kt_${id}_card`}
           onClick={() => setToolbarIcon(!toolbarIcon)}
      >
        <h3 className="card-title align-items-start flex-column">
          <span className={`card-label fw-bolder mb-1 fs-${sm ? 6 : 3}`}>{title}</span>
        </h3>
        <div className="card-toolbar">
            {toolbar}
        </div>
      </div>
      <div className="collapse show" id={`kt_${id}_card`}>
        <div className="card-body p-5 p-sm-8">
          {body}
        </div>
      </div>
    </div>
  )
}

export {CardCollapse}